export default __webpack_public_path__ + "static/CuervoVP-conEscenarioVirtualc-0fad255622760b4a2efb6c5e04a35e7a.jpg";